import { isCulture, type Culture } from './cultures';
import { cultureStorageKey } from './languageContext';

/**
 * The culture the app is running in, readable outside React.
 *
 * `http.ts` needs it to send `Accept-Language`: the backend localises some
 * responses from the request locale (work-item categories), and left to the
 * browser's own header those titles follow the browser's language instead of
 * the culture picked in the app.
 *
 * `LanguageProvider` is the writer. Reads fall back to the stored culture so a
 * request that fires before the provider's effect runs still carries it —
 * child effects run before the parent's.
 */
let active: Culture | null = null;

export const setActiveCulture = (culture: Culture | null): void => {
  active = culture;
};

export const getActiveCulture = (): Culture | null => {
  if (active !== null) {
    return active;
  }
  try {
    const stored: unknown = localStorage.getItem(cultureStorageKey());
    return isCulture(stored) ? stored : null;
  } catch {
    // Storage unavailable (private mode, blocked site data): the browser's own
    // Accept-Language stands, which is what happened before this existed.
    return null;
  }
};
